module.exports = __webpack_public_path__ + "static/media/DUFQorJW0AAXmvd.b90f5028.jpg";